import dayjs from 'dayjs';

/**
 * Returns true if the provided date is within the range defined
 * by fromDate / toDate based on days (not time)
 * @param date Date to compare
 * @param fromDate Start date of range
 * @param toDate End date of range
 * @returns True if date is in range, false if not. False if fromDate/toDate is undefined
 */
export const isDateInRange = (
  date: string | Date,
  fromDate: Date | string | undefined,
  toDate: Date | string | undefined,
): boolean => {
  let djDate = dayjs(date);
  let djFrom = dayjs(fromDate);
  let djTo = dayjs(toDate);
  if (djDate.isBefore(djFrom, 'day') || djDate.isAfter(djTo, 'day')) {
    return false;
  }
  return true;
};
